import React from 'react';
import { theme } from '../../styles/theme';

const DashboardSidebar = ({ activeTab, setActiveTab, userProfile }) => {
  const menuItems = [
    { id: 'orders', label: 'My Orders' },
    { id: 'tracked', label: 'Stock Notifications' },
    { id: 'addresses', label: 'Address Book' },
    { id: 'account', label: 'Account Settings' },
    { id: 'password', label: 'Change Password' },
    { id: 'resale', label: 'Tax Exemption' },
  ];

  const handleMenuItemClick = (itemId) => {
    setActiveTab(itemId);
  };

  const styles = {
    sidebar: {
      backgroundColor: theme.colors.surface,
      borderRadius: theme.borderRadius.lg,
      boxShadow: theme.shadows.md,
      padding: theme.spacing.lg,
      height: 'fit-content',
      transition: theme.transitions.base,
    },
    userWelcome: {
      marginBottom: theme.spacing.xl,
      paddingBottom: theme.spacing.lg,
      borderBottom: `2px solid ${theme.colors.borderLight}`,
    },
    welcomeTitle: {
      fontSize: theme.typography.fontSize.xl,
      fontWeight: theme.typography.fontWeight.bold,
      color: '#8B4513',
      marginBottom: theme.spacing.xs,
      fontFamily: theme.typography.fontFamily.primary,
    },
    welcomeSubtitle: {
      fontSize: theme.typography.fontSize.sm,
      color: theme.colors.textLight,
      fontFamily: theme.typography.fontFamily.secondary,
    },
    navLinks: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing.sm,
    },
    navItem: {
      width: '100%',
      padding: `${theme.spacing.md} ${theme.spacing.lg}`,
      backgroundColor: 'transparent',
      border: `1px solid ${theme.colors.borderLight}`,
      borderRadius: theme.borderRadius.md,
      fontSize: theme.typography.fontSize.base,
      fontWeight: theme.typography.fontWeight.medium,
      color: theme.colors.text,
      cursor: 'pointer',
      transition: theme.transitions.base,
      textAlign: 'left',
      fontFamily: theme.typography.fontFamily.secondary,
    },
    navItemActive: {
      backgroundColor: theme.colors.primary,
      color: theme.colors.textOnDark,
      borderColor: theme.colors.primary,
      fontWeight: theme.typography.fontWeight.semibold,
      boxShadow: theme.shadows.sm,
    },
  };

  // Mobile styles
  const mobileStyles = `
    @media (max-width: 768px) {
      .dashboard-sidebar-container {
        position: static;
        padding: ${theme.spacing.md};
        background-color: ${theme.colors.surface};
        box-shadow: ${theme.shadows.md};
        border-radius: ${theme.borderRadius.md};
      }
      
      .user-welcome-mobile h3 {
        font-size: ${theme.typography.fontSize.lg};
      }
      
      .user-welcome-mobile p {
        font-size: ${theme.typography.fontSize.xs};
      }
    }
    
    @media (min-width: 769px) {
      .dashboard-sidebar-container {
        position: sticky;
        top: ${theme.spacing.lg};
      }
    }
  `;

  return (
    <>
      <style>{mobileStyles}</style>
      <div className="dashboard-sidebar-container" style={styles.sidebar}>
        {/* User Welcome */}
        <div 
          className="user-welcome-mobile"
          style={styles.userWelcome}
        >
          <h3 style={styles.welcomeTitle}>
            Hello, {userProfile?.first_name || 'Guest'}
          </h3>
          <p style={styles.welcomeSubtitle}>Welcome to your dashboard</p>
        </div>
        
        {/* Navigation Links */}
        <nav style={styles.navLinks}>
          {menuItems.map((item) => {
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                style={{
                  ...styles.navItem,
                  ...(isActive ? styles.navItemActive : {}),
                }}
                onClick={() => handleMenuItemClick(item.id)}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.backgroundColor = theme.colors.surfaceAlt;
                    e.currentTarget.style.borderColor = theme.colors.border;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.borderColor = theme.colors.borderLight;
                  }
                }}
              >
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default DashboardSidebar;
